const getFilterText = (option, formatOptionLabel) => {
    const formatted = formatOptionLabel?.(option, {
        context: 'value',
        inputValue: '',
        selectValue: [option],
    });
    if (typeof formatted === 'string') {
        return formatted;
    }
    return typeof option.label === 'string' ? option.label : '';
};
export const matchesSelectFilter = (option, searchText, formatOptionLabel) => getFilterText(option, formatOptionLabel).toLowerCase().includes(searchText.toLowerCase());
